import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/Hotel/tab/Room/Views/room-list.html';
import Pager from '@/Pages/Admin/Modules/Common/Controllers/Pager';
import Spinner from '@/Pages/Admin/Modules/Common/Controllers/Spinner';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import {hotelService} from '@/Pages/Admin/Modules/Hotel/Services/HotelService';
import {RoomModel} from '@/Pages/Admin/Modules/Models/Hotel/RoomModel';

@WithRender
@Component({
  components: {},
}) 
export default class RoomList extends Vue {
 protected ui: any = {};
    protected item: any = {};

    constructor() {
        super();

        this.ui = {
            status: {
                isLoading: {
                    getRoomList: false,
                },
                postLoading: {
                    addRoom: false,
                },
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
                modal: {
                    add: {},
                },
            },
            paging: {
                current_page: 1,
                last_page: 0,
                per_page: 0,
            },
        };

        this.item = {
            roomList: new RoomModel({}),
            addRoom: new RoomModel({}),
        };
    }

    public mounted() {
        this.fetchRoomList();
    }

    get permission() {
        return common.permissionCheck;
    }

    protected fetchRoomList() {
        this.ui.status.isLoading.getRoomList = true;
        let data = {
            hotel_id: this.$route.query.id,
          
        };
        hotelService
            .getRoomList(data)
            .then((res: any) => {
                this.item.roomList = res.data.data;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.getRoomList = false;
            });
    }


    public onEditRoomClick(item: any) {
        this.$router.push({
            name: 'edit-amenity',
            query: {
                id: item.id,
            },
        });
    }

    public createNewRoom(item: any) {
        this.$router.push({
            name: 'create-business-hotel-room-info',
            query: {
               id: this.$route.query.id,
            },
        });
     }
    
    public editRoomInfo(index: any, room: any) {
    this.$router.push({
      name: "edit-business-hotel-room-info",
      query: {
        id: this.$route.query.id,
        rid: room.id
      }
    });
  }
    
    public onPaging(CurrentPage: number) {
        this.ui.paging.current_page = CurrentPage;
        this.fetchRoomList();
    }


    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }
}